interface Holds {
  id: number;
  used: boolean;
}

export interface UsedHold {
  id: number;
  depth: number;
  side?: string;
  svg: {
    height: number;
    width: number;
    rx: number;
    ry: number;
    x: number;
    y: number;
    rectWidth?: number;
    transform?: string;
  };
}

export interface Hangboard {
  holds: Holds[];
  usedHolds: number[];
  name: string;
  handleClick(id: number): Hangboard;
}

interface IHangboardProps {
  usedHolds?: number[];
  hangboard: { name: string; holds: any[] };
}

export class Hangboard implements Hangboard {
  holds: Holds[] = [];
  usedHolds: number[] = [];
  name: string = "";

  constructor(props?: IHangboardProps) {
    if (props) {
      this.usedHolds = props.usedHolds ? [...props.usedHolds] : [];
      this.name = props.hangboard?.name ? props.hangboard.name : "none";
      this.holds = [];
      if (props.hangboard?.holds) {
        props.hangboard.holds.forEach((hold: any) => {
          this.holds.push({
            used: this.usedHolds.includes(hold.id) ? true : false,
            id: hold.id,
          });
        });
      }
    }
  }

  handleClick(id: number): Hangboard {
    this.updateUsedHolds(id);
    this.holds.forEach((hold) => {
      hold.used = this.usedHolds.includes(hold.id);
    });
    return this;
  }

  updateUsedHolds(newHoldId: number) {
    const holdIndex = this.holds.findIndex(hold => hold.id === newHoldId);
    if (holdIndex === -1) return;
    
    if (this.holds[holdIndex].used) {
      this.usedHolds = this.usedHolds.filter((id) => id !== newHoldId);
    } else {
      this.usedHolds.push(newHoldId);
    }
    
    if (this.usedHolds.length > 2) {
      this.usedHolds.shift();
    }
  }
}
